/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Coaching_Pdf_InactiveInputs */

const en_us2_coaching_pdf_inactive = /** @type {(inputs: Coaching_Pdf_InactiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Not trained for ${i?.days} days or more.`)
};

const pt_br2_coaching_pdf_inactive = /** @type {(inputs: Coaching_Pdf_InactiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sem treinar há ${i?.days} dias ou mais.`)
};

const pt_pt2_coaching_pdf_inactive = /** @type {(inputs: Coaching_Pdf_InactiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sem treinar há ${i?.days} dias ou mais.`)
};

/** @type {(inputs: Coaching_Pdf_InactiveInputs) => LocalizedString} */
const es_419_coaching_pdf_inactive = en_us2_coaching_pdf_inactive;

/** @type {(inputs: Coaching_Pdf_InactiveInputs) => LocalizedString} */
const fr_fr2_coaching_pdf_inactive = en_us2_coaching_pdf_inactive;

/** @type {(inputs: Coaching_Pdf_InactiveInputs) => LocalizedString} */
const de_de2_coaching_pdf_inactive = en_us2_coaching_pdf_inactive;

/** @type {(inputs: Coaching_Pdf_InactiveInputs) => LocalizedString} */
const it_it2_coaching_pdf_inactive = en_us2_coaching_pdf_inactive;

/**
* | output |
* | --- |
* | "Not trained for {days} days or more." |
*
* @param {Coaching_Pdf_InactiveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_pdf_inactive = /** @type {((inputs: Coaching_Pdf_InactiveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Pdf_InactiveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_pdf_inactive(inputs)
	if (locale === "es-419") return es_419_coaching_pdf_inactive(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_pdf_inactive(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_pdf_inactive(inputs)
	if (locale === "de-DE") return de_de2_coaching_pdf_inactive(inputs)
	if (locale === "it-IT") return it_it2_coaching_pdf_inactive(inputs)
	return en_us2_coaching_pdf_inactive(inputs)
});
export { coaching_pdf_inactive as "coaching.pdf_inactive" }